import React, { Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import { string, func } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { urlPathToObject } from '../../helpers/common'
import Button from '../ui/button/Button'
import { emptyStateMessages as messages } from './messages'

const ResultsEmptyState = ({ site, query, clearFilters, searchType }) => {
  const history = useHistory()
  const hasSelectedFilters = !!Object.keys(urlPathToObject(document.location, searchType)).length
  const siteDomain = site === 'us' ? '' : `/${site}`
  return (
    <Fragment>
      <h3 className={'afd-title-big afd-title-big--bmargin-big'}>
        <FormattedMessage values={{ query }} {...messages.noResults} />
      </h3>
      <h3 className={'afd-title-middle'}>
        <FormattedMessage {...messages.suggestions} />:
      </h3>
      <ul className='srch-empty-state__list'>
        <li className='srch-empty-state__item'>
          <FormattedMessage {...messages.suggestion1} />
        </li>
        <li className='srch-empty-state__item'>
          <FormattedMessage {...messages.suggestion2} />
        </li>
        <li className='srch-empty-state__item'>
          <FormattedMessage {...messages.suggestion3} />
        </li>
        <li className='srch-empty-state__item'>
          <FormattedMessage {...messages.suggestion4} />
        </li>
      </ul>
      <div className='srch-empty-state__actions'>
        <Button mainClass='afd-btn' onClick={history.goBack}><FormattedMessage {...messages.goBack} /></Button>
        {hasSelectedFilters && (
          <Button mainClass='afd-btn' onClick={clearFilters}><FormattedMessage {...messages.clearFilters} /></Button>
        )}
      </div>
      <h3 className={'afd-title-middle'}>
        <FormattedMessage {...messages.stillNotFound} />
      </h3>
      <a className='srch-empty-state__feedback' href={`${siteDomain}/contact?ad_name=search`}>
        <FormattedMessage {...messages.sendFeedback} />
        {` >>`}
      </a>
    </Fragment>
  )
}

ResultsEmptyState.propTypes = {
  query: string.isRequired,
  site: string,
  searchType: string,
  clearFilters: func
}

export default ResultsEmptyState
